/** Utilitários de sobreposição de slots (espelha a lógica do servidor). */

function parseMinutes(hhmm: string): number | null {
  const m = String(hhmm || '')
    .trim()
    .match(/^(\d{1,2}):(\d{2})/)
  if (!m) return null
  const h = Number(m[1])
  const min = Number(m[2])
  if (h < 0 || h > 23 || min < 0 || min > 59) return null
  return h * 60 + min
}

export function rangesOverlap(
  startA: string | number,
  durA: number,
  startB: string | number,
  durB: number
): boolean {
  const a0 = typeof startA === 'number' ? startA : parseMinutes(startA)
  const b0 = typeof startB === 'number' ? startB : parseMinutes(startB)
  if (a0 == null || b0 == null) return false
  const a1 = a0 + Math.max(1, durA)
  const b1 = b0 + Math.max(1, durB)
  return a0 < b1 && b0 < a1
}

export function filterSlotsAgainstBusy(
  slots: string[],
  busy: Array<{ hora: string; duracao_minutos: number }>,
  durationMin: number
): string[] {
  const duration = Math.max(5, durationMin || 60)
  return slots.filter((slot) => {
    const start = parseMinutes(slot)
    if (start == null) return false
    return !busy.some((b) =>
      rangesOverlap(start, duration, b.hora, Number(b.duracao_minutos) || 60)
    )
  })
}
